import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { websiteOffer } from '../content/websiteOffer';
import styles from '../pages/RemodelingWebsites.module.css';

export function WebsitePackage({ landing = false }: { landing?: boolean }) {
  return <section id="package" className={styles.packageSection} aria-labelledby="website-package-title">
    <div className={styles.wrap}>
      <div className={styles.packageGrid}>
        <div>
          <p className={styles.eyebrow}>THE WEBSITE PACKAGE</p>
          <h2 id="website-package-title">A clear scope.<br />A price you can plan for.</h2>
          <p className={styles.packageIntro}>Everything a straightforward business website needs to show your work and help customers get in touch.</p>
          <p className={styles.pageList}>{websiteOffer.pages.join(' / ')}</p>
        </div>
        <div className={styles.pricePanel}>
          <div className={styles.priceLine}><strong>{websiteOffer.price}</strong><span>one-time build<br />up to 5 pages</span></div>
          <p className={styles.costDisclosure}>{websiteOffer.recurringCosts}</p>
          <ul className={styles.inclusions}>{websiteOffer.inclusions.map(item => <li key={item}><Check size={18} aria-hidden="true" />{item}</li>)}</ul>
          {landing ? <a className={styles.button} href="#request">Request my free demo <ArrowRight size={18} aria-hidden="true" /></a> : <Link className={styles.button} to="/free-demo">Request my free demo <ArrowRight size={18} aria-hidden="true" /></Link>}
          <p className={styles.finePrint}>No payment for the demo. If you proceed: {websiteOffer.deposit} deposit after scope approval, with the balance due at the agreed launch milestone.</p>
        </div>
      </div>
      <p className={styles.exclusions}>{websiteOffer.exclusions} Delivery dates are agreed after we review your materials and availability.</p>
    </div>
  </section>;
}
